import { render, staticRenderFns } from "./ModalPrograms.vue?vue&type=template&id=1c1d2740&"
import script from "./ModalPrograms.vue?vue&type=script&lang=js&"
export * from "./ModalPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports